/* eslint-disable no-unused-vars */
import { current } from 'daisyui/colors';
import React, { useContext, useEffect, useState } from 'react';
import Graph from 'react-graph-vis';
import { Link } from 'react-router-dom';
import { Artist1Context, Artist2Context } from '../context';
import api from '../requests/api';

const options = {
  width: '100%',
  height: `${window.screen.height}px`,
  layout: {
    hierarchical: false,
  },
  physics: {
    stabilization: {
      enabled: true,
      iterations: 10,
    },
    timestep: 0.2,
    barnesHut: {
      damping: 0.7,
      springConstant: 0.1,
      springLength: 150,
    },
  },
  edges: {
    color: '#FFFFFF',
  },
  nodes: {
    shape: 'circularImage',
    font: '15px arial white',
    size: 40,
    mass: 5,
  },
};

export default function Game() {
  const [firstArtist, setFirstArtist] = useContext(Artist1Context);
  const [secondArtist, setSecondArtist] = useContext(Artist2Context);
  const [currentArtist, setCurrentArtist] = useState(firstArtist);
  const [currentRelatedArtists, setCurrentRelatedArtists] = useState(null);
  const [currentArtistData, setCurrentArtistData] = useState([firstArtist]);
  const [graph, setGraph] = useState({
    nodes: [],
    edges: [],
  });
  useEffect(async () => {
    const res = await api.getRelatedArtistsRequest(currentArtist.id);
    setCurrentRelatedArtists(res);
    const newGraph = {
      nodes: [
        {
          id: currentArtist.id,
          label: currentArtist.name,
          image: currentArtist.images[0].url,
        },
      ],
    };
    newGraph.nodes = [
      ...newGraph.nodes,
      ...res.map((artist) => ({
        id: artist.id,
        label: artist.name,
        image: artist.images[0].url,
      })),
    ];
    newGraph.edges = res.map((artist) => ({
      from: currentArtist.id,
      to: artist.id,
    }));
    setGraph(newGraph);
  }, [currentArtist]);

  function goBackOne() {
    if (currentArtistData.length > 1) {
      const newArtist = currentArtistData[currentArtistData.length - 2];
      setCurrentArtistData(currentArtistData.slice(0, -1));
      setCurrentArtist(newArtist);
    }
  }
  const events = {
    select(event) {
      const { nodes, edges } = event;
      if (nodes[0] !== undefined && nodes[0] !== currentArtist.id) {
        setCurrentArtist(
          currentRelatedArtists.find((artist) => artist.id === nodes[0]),
        );
        setCurrentArtistData((e) => [
          ...e,
          currentRelatedArtists.find((artist) => artist.id === nodes[0]),
        ]);
      }
    },
  };
  return (
    <div>
      <Link to="/" className="absolute top-3 left-3 text-white text-xl z-50">Back</Link>
      <button onClick={goBackOne} className="absolute top-3 left-20 text-white text-xl z-50" type="button">
        Undo
      </button>
      {currentArtist.name !== secondArtist.name ? (
        <Graph graph={graph} options={options} events={events} />
      ) : (
        <div className="flex flex-col items-center justify-center bg-gradient-to-b from-black to-zinc-800 w-full min-h-screen">
          <h1 className="text-white text-xl mb-8">You Win!</h1>
          <div className="flex flex-row flex-wrap items-center justify-center">
            <div className="flex flex-col items-center">
              <h1 className="mb-2 text-white w-40 text-center">
                {firstArtist.name}
              </h1>
              {firstArtist.images?.length > 0 && (
              <img
                src={firstArtist.images[0].url}
                alt="artist"
                className="drop-shadow w-20 h-20 rounded-full border-2 border-white"
              />
              )}
            </div>
            {
              currentArtistData.map(
                (artist, i) => {
                  if (i !== 0) {
                    return (
                      <>
                        <div className="w-60 border-t-2 border-white border-dashed" />
                        <div className="flex flex-col items-center">
                          <h1 className="mb-2 text-white w-40 text-center">
                            {artist.name}
                          </h1>
                          {artist.images?.length > 0 && (
                          <img
                            src={artist.images[0].url}
                            alt="artist"
                            className="drop-shadow w-20 h-20 rounded-full border-2 border-white"
                          />
                          )}
                        </div>
                      </>
                    );
                  }
                  return <div />;
                },
              )
            }
          </div>
        </div>
      )}
    </div>
  );
}
